module.exports = __webpack_public_path__ + "img/pen-edit.180b53b1.svg";